import styled from 'styled-components';
import { FlexCenter } from './flex';

export default styled(FlexCenter)`
  margin-left: 30px;
`;
